<template>
  <div>
    <ResetPassword />
  </div>
</template>

<script>
import ResetPassword from "@/components/Account/ResetPassword.vue";
export default {
  components: {
    ResetPassword,
  },
};
</script>

<style></style>
